import { Link } from 'react-router-dom';
import { ArrowLeft, Star } from 'lucide-react';
import { RoiCalculator } from '@/components/RoiCalculator';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72ee028-442b-44ea-ad3d-be1abd62a5cf/artifacts/zdjtc3rc_Logo_Falo_com_o_dono-removebg-preview.png";

const CalcularPerda = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0A2647] via-[#0c2d52] to-[#071A33]" data-testid="calc-perda-page">
      {/* Header */}
      <header className="relative pt-6 pb-4 px-4 border-b border-white/5">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-white/70 hover:text-white transition" data-testid="back-link">
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm font-medium">Voltar</span>
          </Link>
          <Link to="/" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="FaloComODono" className="h-10 object-contain" />
          </Link>
        </div>
      </header>

      {/* Hero curto */}
      <section className="pt-12 pb-10 px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-[#C5A059]/10 border border-[#C5A059]/25 rounded-full px-4 py-1.5 mb-5">
            <Star className="w-3.5 h-3.5 text-[#C5A059] fill-[#C5A059]" />
            <span className="text-xs font-bold text-[#C5A059] uppercase tracking-wider">Diagnóstico grátis em 10 segundos</span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-5">
            Descubra <span className="text-rose-400">quanto seu negócio</span><br className="hidden sm:block" />
            está perdendo agora.
          </h1>

          <p className="text-base sm:text-lg text-white/60 max-w-2xl mx-auto leading-relaxed">
            91% dos clientes insatisfeitos não reclamam — eles simplesmente não voltam. Calcule em segundos quanto isso pode estar custando ao seu caixa.
          </p>
        </div>
      </section>

      {/* Calculadora */}
      <section className="pb-16 px-4">
        <div className="max-w-5xl mx-auto">
          <RoiCalculator
            ctaText="Quero recuperar essa receita agora"
            ctaHref="/#pricing-section"
            variant="dark"
          />
        </div>
      </section>

      {/* Trust footer */}
      <section className="pb-16 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs text-white/40 mb-4 uppercase tracking-wider">Já confiam no FaloComODono</p>
          <div className="flex items-center justify-center gap-6 text-white/30">
            <div className="text-center">
              <p className="text-2xl font-extrabold text-[#C5A059]">+500</p>
              <p className="text-[11px]">Empresas</p>
            </div>
            <div className="w-px h-8 bg-white/10" />
            <div className="text-center">
              <p className="text-2xl font-extrabold text-[#C5A059]">+25k</p>
              <p className="text-[11px]">Avaliações</p>
            </div>
            <div className="w-px h-8 bg-white/10" />
            <div className="text-center">
              <p className="text-2xl font-extrabold text-[#C5A059]">10s</p>
              <p className="text-[11px]">Para avaliar</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CalcularPerda;
